export enum FillNowExecutionState {
  INIT,
  LOCKING,
  LOCKED,
  FILLING,
  EXT_ACCEPTANCE,
  UNLOCKING,
  /** Order unlocked due to successful fill now action */
  UNLOCKED_SUCCESS,
  /** Order unlocked due to failed fill now action */
  UNLOCKED_FAIL,
  /** ORder unlocked externally */
  UNLOCKED_EXTERNAL,
  /** Order unlocked externally and terminal */
  UNLOCKED_TERMINAL,
}
